import { all, takeEvery,call, put, fork } from 'redux-saga/effects';
import { notification } from '@iso/components';

import { getToken, clearToken } from '@iso/lib/helpers/utility';
import JwtAuthentication from '@iso/lib/helpers/jwtAuthentication';
import { setCookie, removeCookie } from '@iso/lib/helpers/session';
import actions from './actions';

const fakeApiCall = true; // auth0 or express JWT

export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', function*({ payload }) {
    const { token } = payload;
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: token,
        profile: 'Profile',
      });
    } else {
      if (fakeApiCall) {
        yield put({
          type: actions.LOGIN_SUCCESS,
          token: 'secret token',
          profile: 'Profile',
        });
      } else {
        yield put({ type: actions.LOGIN_ERROR });
      }
    }
  });
}


export function* jwtLoginRequest() {
  console.log("Inside jwt login request");
  yield takeEvery(actions.JWT_LOGIN_REQUEST, function*({ payload }) {
    console.log("takeEvery",payload.userInfo);
    const result = yield call(JwtAuthentication.login, payload.userInfo);

    console.log('result',result);
    //return;
    if (result.status===0) {
      notification('error', result.message);
      yield put({ type: actions.LOGIN_ERROR });
    } else {
      if(result.status){
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: result.jwt_token,
        id: result.id,
        role: result.role,
        profile: result.profile,
        u_id: result.user_id,
        u_email: result.user_email
      });
     // payload.history.push('/dashboard');
     window.location.href = '/dashboard/categorytree';
    }else{
      if (result.error) {
        notification('error', result.error);
      }
      //payload.history.push('/signin');
    }
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function*(payload) {
    yield localStorage.setItem('id_token', payload.token);
    setCookie('login_saga', payload.token);
    setCookie("uId", payload.u_id); //NEW
    setCookie("uEmail", payload.u_email); //NEW
    yield setCookie('id_token', payload.token);
    
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function*() {});
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function*() {
    removeCookie('id_token');
    removeCookie('login_saga');
    removeCookie("uId");  //NEW
    removeCookie("uEmail"); //NEW
    yield clearToken();
   // history.push('/');
   window.location.href = '/signin';
  });
}
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function*() {
    const token = getToken().get('idToken');
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        profile: 'Profile',
      });
    }
  });
}


export default function* rootSaga() {
  yield all([
  //  fork(checkAuthorization),
    fork(loginRequest),
    fork(jwtLoginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
  ]);
}
